var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-selection-radio',{attrs:{"characteristic":_vm.characteristic,"doorConfigurationProp":_vm.context}})}
var staticRenderFns = []

export { render, staticRenderFns }